var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group"},[_c('Row',{attrs:{"type":"flex","justify":"space-between"}},[_c('h4',{staticClass:"ti"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/yxUIComponent/custom/boxWithTitle2.vue